import cipher24Image from '../../../../assets/images/games/zdar-escape-game/ciphers/24/image.webp';

export const step24trees = {
    id: 22,
    title: '10. stanoviště',
    taskText: `
        <p>
            Hotovo, myslím, že už se tomu musíme dostávat pomalu na kloub, ale vůbec netuším, kam to směřuje. Co mohli ukrást, co myslíš? Něco, co by vadilo i starostovi a muzeu? K čemu nás všechny ty věci navádí? Třeba bychom se měli začít bát, třeba je to něco nebezpečného :O 
        </p>
        <p>
            A teď co? Jdeme asi podle mapky na označený bod. 
        </p>
    `,
    catImage: 8,
    cipher: {
        images: [cipher24Image],
    },
    continueButtonText: 'Jsme na místě',
};
